import React from 'react';
import agent from '../../agent';
import GenericOutput from '../GenericOutput';
import LoadingIndicator from '../LoadingIndicator';
import { SITE_UPDATED, TABLE_COLUMNS_LOADED } from '../../constants/actionTypes';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import cache from '../../cache';
import { debounce, wait, getRecordsModifiedAfter } from '../../utils';
import db from '../../db';

const mapStateToProps = state => ({
  tables: state.tables,
  isLocalDbGood: state.common.isLocalDbGood
});

const mapDispatchToProps = dispatch => ({
  updateSite: payload =>
    dispatch({ type: SITE_UPDATED, payload }),
  updateColumns: payload =>
    dispatch({ type: TABLE_COLUMNS_LOADED, payload }),
});


class ListRecords extends React.Component {
  constructor() {
    super();

    this.state = { 
      searchKey: '',
      table: {
        columns: []
      },
      dataList: [],
      backupList: [],
      isInitialized: false,
      showLoading: true,
    };
    this.initializeListView = this.initializeListView.bind(this);
    this.deleteRecord = this.deleteRecord.bind(this);
    this.refreshList = this.refreshList.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.waitForLocalDb = this.waitForLocalDb.bind(this);
    this.serverSearch = this.serverSearch.bind(this);
    this.localSearch = this.localSearch.bind(this);
    this.doSearch = debounce(searchTerm => {
      this.localSearch(searchTerm);
    }, 350)
  }

  async waitForLocalDb(time) {
    for(let i = 0; i < 5; i++) {
      if(this.props.isLocalDbGood) {
        break;
      }else {
        await wait(time/5);
      }
    }
  }

  async refreshList() {
    let {tableId} = this.props.match.params;
    this.setState({showLoading: true});
    let dataList = await agent.Data.getAll(tableId).catch(console.log);
    this.setState({isInitialized: true, dataList, showLoading: false, backupList: dataList});
    cache.saveRecordList(tableId, dataList);
  }

  async initializeListView(tableId) {
    await this.waitForLocalDb(100);
    let cacheRecords = [];
    if(this.props.isLocalDbGood) {
      cacheRecords = await cache.getRecordList(tableId);
    }
    if(cacheRecords.length == 0) {
      this.refreshList();
    }else {
      this.setState({isInitialized: true, dataList: cacheRecords, backupList: cacheRecords});

      let lastModifiedTime, lastRecordId;
      cacheRecords.forEach(rec => {
        if(!lastModifiedTime || lastModifiedTime < rec.modifiedAt) {
          lastModifiedTime = rec.modifiedAt;
          lastRecordId = rec.id;
        }
      });

      let newRecords = await getRecordsModifiedAfter(this.state.table.id, lastModifiedTime, lastRecordId);
      console.log('Get new data after', lastModifiedTime, lastRecordId, newRecords);
      let newList = [];
      let newIdList = [];
      newRecords.forEach(newRec => {
        newList.push(newRec);
        newIdList.push(newRec.id);
      });
      this.state.backupList.forEach(uiRecord => {
        if(newIdList.indexOf(uiRecord.id) === -1) {
          newList.push(uiRecord);
        }
      });
      this.setState({dataList: newList, showLoading: false, backupList: newList});
      cache.saveRecordList(tableId, newRecords);
    }
  }

  handleSearchChange(event) {
    let searchKey = event.target.value;
    this.setState({searchKey});
    if(searchKey.length > 2) {
      this.doSearch(searchKey);
    }else {
      let dataList = [...this.state.backupList];
      this.setState({dataList})
    }
  }

  localSearch(searchKey) {
    let resultList = [];
    if(searchKey.length > 2) {
      let textColumns = [];
      this.state.table.columns.forEach(column => {
        if(column.type == 'string') {
          textColumns.push(column.name);
        }
      });
      db.getAll(this.props.match.params.tableId)
        .then(resList => {
          searchKey = searchKey.toLowerCase();
          resList.forEach(res => {
            let isAdded = false;
            textColumns.forEach(column => {
              if(!isAdded && res[column] && res[column].toLowerCase().indexOf(searchKey) != -1) {
                resultList.push(res);
                isAdded = true;
              }
            });
          });
          let currentKey = this.state.searchKey;
          if(currentKey && currentKey.length >= 2) {
            this.setState({dataList: resultList});
          }else {
            let dataList = [...this.state.backupList];
            this.setState({dataList})
          }
        });
    }
  }

  serverSearch(searchKey) {
    var strlength = searchKey.length;
    var strFrontCode = searchKey.slice(0, strlength-1);
    var strEndCode = searchKey.slice(strlength-1, searchKey.length);

    var startcode = searchKey;
    var endcode= strFrontCode + String.fromCharCode(strEndCode.charCodeAt(0) + 1);
    let searchList = [{
        column: "name",
        operator: ">=", 
        value: startcode
      },{
        column: "name",
        operator: "<", 
        value: endcode
      }];

    agent.Data.search(this.props.match.params.tableId, searchList)
      .then(res => {
        console.log(res);
      });
  }

  deleteRecord(dataId, event) {
    event.preventDefault();
    let tableId = this.props.match.params.tableId;
    agent.Data.deleteRow(tableId, dataId)
      .then(res => {
        cache.deleteRecord(tableId, dataId);
        console.log(res);
        let dataList = this.state.dataList.filter(item => item.id !== dataId);
        this.setState({dataList});
      });
  }

  static getDerivedStateFromProps(props, state) {
    let { isInitialized } = state;
    if(state.table.id !== props.match.params.tableId) {
      isInitialized = false;
    }
    if (props.tables && props.tables.length > 0 && !isInitialized) {
      let currentTable = state.table;
      props.tables.forEach(table => {
        if(props.match.params.tableId === table.id) {
          currentTable = Object.assign({}, table);
        }
      });
      const newState = Object.assign({}, {isInitialized: true, table: currentTable, dataList: []});
      return newState;
    }
    return null;
  }

  componentDidMount() {
    this.initializeListView(this.state.table.id);
  }

  componentDidUpdate(prevProps) {
    if(this.state.table.id && this.state.table.id !== prevProps.match.params.tableId) {
      this.initializeListView(this.state.table.id);
    }
  }

  render() {
    return (
      <div className="container">
        <div>
          <div className="row margin-vertical-10">
            <div className="col-md-4 col-sm-12 col-xs-12">
              <div className="flex-center-container">
                <button onClick={this.refreshList} className="btn btn-outline-primary">Refresh All</button>
              </div>
            </div>
            <div className="col-md-4 col-sm-12 col-xs-12">
              <div className="flex-center-container">
                <input type="text" name="search" className="search-btn" onKeyUp={this.handleSearchChange} placeholder={this.state.table.pluralLabel && 'Search for '+ this.state.table.pluralLabel.toLowerCase() +' here'}></input>
              </div>
            </div>
            <div className="col-md-4 col-sm-12 col-xs-12">
              <div className="flex-center-container">
                <Link to={'/table/'+this.state.table.id+'/new'} className="btn btn-warning">Create new {this.state.table.id}</Link>
              </div>
            </div>
          </div>
          <h5>List of all {this.state.table.pluralLabel}</h5>
          <LoadingIndicator isShow={this.state.showLoading}/>
          <table className="table table-striped table-bordered table-hover">
            <thead>
              {this.state.isInitialized &&
                <tr>
                  <td>Actions</td>
                  {this.state.table.columns.map(column => <td key={column.name}>{column.label}</td>)}
                </tr>
              }
            </thead>
            <tbody>
                {this.state.isInitialized && this.state.dataList.map(data => 
                  <tr key={data.id}>
                    <td>
                      <Link to={'/table/'+this.state.table.id+'/'+data.id+'/edit'}>Edit</Link>
                      &nbsp;|&nbsp;  
                      <Link to={'/table/'+this.state.table.id+'/'+data.id+'/view'}>View</Link>
                      &nbsp;|&nbsp;  
                      <a onClick={this.deleteRecord.bind(this, data.id)} href="#">Delete</a>
                    </td>
                    {this.state.table.columns.map(column => <td key={data.id+column.name}>
                        <GenericOutput column ={column} value={data[column.name]}/>
                      </td>
                    )}
                  </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ListRecords);
